jQuery(document).ready(function($) { 

/* *****************  */
  /* INITIALISATION */
initSlideClient();
initTeamMobile();
toInitReadMore(); 
InitBtnHomeLightbox();
toInitSlideAbout();
function transitionsSupported() {
    return $('html').hasClass('csstransitions');
}


// function ForIE11Trasnform() {
// $(".LogotoPicto .site-branding svg .logo_lettre").each(function(){
//         transform = jQuery(this).css('transform');
//         console.log(transform);
//         jQuery(this).attr('transform',transform);
//     });
// }




 /* *****************  */
  /*  NAV SCROLL POUR PAGE INVESTISOR */
  $("body").on("click",".InvestorNav a:not(.js-ajax-link)" , function(evt){
      var page = $(this).attr('href'); // ELT cible
      var speed = 450; // Durée de l'animation (en ms)
      $('html, body').animate( { scrollTop: $(page).offset().top-110 }, speed ); // Go
     evt.preventDefault();
  });

/* *****************  */
/* FORM LOGIN / INVESTISOR   */
/* *****************  */

   /* *****************  */
  /*  GESTION APPARITION / DISPIRATION BLOCK LOGIN */
  var $BlockLogin = $('.js-InvestorLogin');

  /* APPARAITRE FORMULAIRE DROITE LOGIN */
  $( ".js-ajax-login, .js-InvestorLogin-Close" ).click(function(evt) {

    if($('body').hasClass('logged-in')){
        // On est loggué, donc pas besoin d'afficher la barre latérale, et de toute façon si on triche, on verra le formulaire de login...
         NextHref = beautiful_login_object.redirection_form_login; // 'http://localhost/site-aeronautics-fund/investisor/ ou quarterly-report en fonction de la page d'appel 

          //if the page is not already being animated - trigger animation
          if( !isAnimating ) GoToPage('investor', true);
           firstLoad = true; 


         
    }else{
     $BlockLogin.toggleClass(('Toappear'));
     $('body').toggleClass(('BlockLoginToappear'));

     // document.getElementById("user").focus();
      
   }
   evt.preventDefault();
  });

  function OncliCkMessage(){

      var $MESSAGE = $("#message");

      $MESSAGE.on('input', function() {
      var scroll_height = $MESSAGE.get(0).scrollHeight;
      if (scroll_height > 100){
        $MESSAGE.css('resize', 'vertical');
        $MESSAGE.css('overflow-y', 'auto');
      }else{
        $MESSAGE.css('resize', 'none');
        $MESSAGE.css('height', scroll_height-6 + 'px');
        $MESSAGE.css('resize', 'hidden');
      }  

    });

   }

   OncliCkMessage();


  var lFollowX = 0,
      lFollowY = 0,
      x = 0,
      y = 0,
      friction = 1 / 30;

  function mouseOurFleet() {
    x += (lFollowX - x) * friction;
    y += (lFollowY - y) * friction;
    
   // console.log(x);

    translate = 'translate(' + x + 'px, ' + y + 'px) scale(1.1)';

    $('#js-mouse-move').css({
      '-webit-transform': translate,
      '-moz-transform': translate,
      'transform': translate
    });

    window.requestAnimationFrame(mouseOurFleet);
  }

  function EventMoveMouse(){

      $('#section2.OurFleet').on('mousemove click', function(e) {

      var lMouseX = Math.max(-100, Math.min(100, $(window).width() / 2 - e.clientX));
      var lMouseY = Math.max(-100, Math.min(100, $(window).height() / 2 - e.clientY));
      lFollowX = (20 * lMouseX) / 100; // 100 : 12 = lMouxeX : lFollow
      lFollowY = (10 * lMouseY) / 100;



    });


  }
  mouseOurFleet();


  





  /* FORM AJAX */
    $('form#beautiful-login').on('submit', function(e){
        
         $('form#beautiful-login .error-inner').text(beautiful_login_object.loadingmessage);
         $('form#beautiful-login .error').slideDown();
          $.ajax({
              type: 'POST',
              dataType: 'json',
              url: beautiful_login_object.ajaxurl,
              data: { 
                  'action': 'ajaxlogin',
                  'log': $('form#beautiful-login #user').val(), 
                  'pwd': $('form#beautiful-login #password').val(), 
                  'security': $('form#beautiful-login #security').val()
              },
              success: function(data){
                  $('form#beautiful-login .error').addClass('appear');
                  $('form#beautiful-login .error-inner').text(data.message);
                  if (data.loggedin == true){
                     //document.location.href = beautiful_login_object.redirecturl;
                      $('form#beautiful-login .error').removeClass('appear');
                        NextHref = beautiful_login_object.redirection_form_login; // 'http://localhost/site-aeronautics-fund/investisor/ ou quarterly-report en fonction de la page d'appel

                        // On enleve quelques class puisque on est sur la page /investisor/ est on est pas loggué. On a fait apparaitre par défaut le formulaire sur la droite.
                        if($('body').hasClass('SpecialNotLogged')){
                          $('body').removeClass('SpecialNotLogged');
                          $('.InvestorLogin').removeClass('Toappear');
                        }

                      $('body').addClass('logged-in');
                      if( !isAnimating ) GoToPage(beautiful_login_object.page_to_go_after_login, true);
                       $('#menu_primary li').removeClass('current-menu-item');
                       $('#menu_primary li a[data-page="investor"]').parent().addClass('current-menu-item');
                      
                      firstLoad = true; 

                  }
              }
          });
          e.preventDefault();
      });

/* *****************  */
/* FIN / FORM LOGIN / INVESTISOR   */
/* *****************  */


/* *****************  */
/* VARIABLE / INIT   */
/* *****************  */

  var fullPageCreated = false;
  var NewHtml;
  var argsFullPage;
  var NextHref = '';
  var allClassPage = 'bodypage_team bodypage_about bodypage_investor bodypage_contact bodypage_quarterly-report'; /* ICI SI AJOUT DE PAGE */
  var $sitenavigation = $("#site-navigation");
  var TitlePage;
  var OldPage = '';
  var NbCurrentSlide = 0;
  var Quel_page = '';
  var DelayTransition = 1200;
  var isAnimating = false;
  var firstLoad = false;
  var CurrentPage = '';

$('body').addClass('page-is-changing');
 setTimeout(function(){
  $('body').removeClass('page-is-changing'); // Fais apparaitre le contenu
  $('.cd-loading-bar').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
      isAnimating = false;

      //
      // Variable a false, on peut de nouveau jouer l'animation
    $('.cd-loading-bar').off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend');
  });
  },100);


  /* *****************  */
    /* FULLPAGE : OPTION POUR PAGE ABOUT    */
  /* *****************  */

  var optionFullPageAbout = {
      licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
      lockAnchors:false, // hum, on ne peut plus se servir de precedent / suivant en interne dans les pages...
      anchors:['Intro', 'Context', 'Media', 'Our-fleet', 'Clients-partners', 'Memberships'], // Si on ajoute une sectin dans about, le faire ici
      verticalCentered: false,
      css3: true,
      onLeave: function(index, newIndex, direction){
        if (direction == 'down'){
          $('.section').eq(index.index -1).removeClass('moveDown').addClass('moveUp');
        }
        else if(direction == 'up'){
          $('.section').eq(index.index -1).removeClass('moveUp').addClass('moveDown');
        }

        $('body').addClass('SlideTransition');
        

       
        // DEUX CLASS POUR SAVOIR SI ON DOIT METTRE LOGO + NAV EN BLANC OU BLEU : header_blanc et header_bleu
       if(newIndex.item.classList.contains('header_bleu')){
          $('body').removeClass('bg_bleu');
        }else{
           $('body').addClass('bg_bleu');
        }

         // 1 CLASS POUR SAVOIR SI ON DOIT METTRE LOGO EN PETIT  : LogotoPicto
        if(newIndex.item.classList.contains('LogotoPicto')){
          $('body').addClass('LogotoPicto');
        }else{
           $('body').removeClass('LogotoPicto');
        }

        // 1 CLASS POUR SAVOIR SI ON DOIT METTRE LOGO EN BLANC  : PictoBlanc
        if(newIndex.item.classList.contains('PictoBlanc')){
          $('body').addClass('PictoBlanc');
        }else{
           $('body').removeClass('PictoBlanc');
        }

        $('.js-active-link li').removeClass('current-menu-item');
        $('.js-active-link li[data-menuanchor="'+newIndex.anchor+'"]').addClass('current-menu-item');
        
     
        NbCurrentSlide = newIndex.index;
        // PLAY VIDEO SI ON REVIENT DESSUS 
        if(NbCurrentSlide == 0){
          $("#video_home").get(0).play();
        }

        // SO ON QUITTE LA HOME // ON MET LA VIDEO EN PAUSE 
        if(index.index == 0){
          $("#video_home").get(0).pause();
        }

        //ForIE11Trasnform();
           

      },
      afterLoad : function(index, newIndex, direction){
        $('body').removeClass('SlideTransition');
      }
    };

   
  /* *****************  */
    /* FULLPAGE : OPTION POUR PAGE TEAM    */
  /* *****************  */

  var optionFullPageTeam = {
      licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
      lockAnchors:false, // hum, on ne peut plus se servir de precedent / suivant en interne dans les pages...
      anchors:['Team', 'laurent-biousse', 'stephan-woestelandt','jerome-guichard', 'alain-gafundi'], // si on ajoute un membre de l'équipe, il faut le rajouter ici
      verticalCentered: false,
      css3: true,
      responsiveWidth: 769,
      afterResponsive: function(isResponsive){
          // ICI fonction pour le tabs ?
          if(isResponsive){$('.Team-Left-Txt-Title').addClass('barre_diago GoToTop GoToTop--delay2 animated'); }
          else { $('.Team-Left-Txt-Title').removeClass('barre_diago GoToTop GoToTop--delay2 animated'); }
      },
      
      onLeave: function(index, newIndex, direction){
        if (direction == 'down'){
          $('.section').eq(index.index -1).removeClass('moveDown').addClass('moveUp');
        }
        else if(direction == 'up'){
          $('.section').eq(index.index -1).removeClass('moveUp').addClass('moveDown');
        }
        $('body').addClass('SlideTransition');
        //console.log(newIndex.index);
        $('.js-active-link li').removeClass('current-menu-item');
        $('.js-active-link li[data-menuanchor="'+newIndex.anchor+'"]').addClass('current-menu-item');

         NbCurrentSlide = newIndex.index;
          //ForIE11Trasnform();
      },
      afterLoad : function(index, newIndex, direction){
        $('body').removeClass('SlideTransition');
      }
    };

     
  /* *****************  */
    /* FULLPAGE : OPTION POUR PAGE CONTACT    */
  /* *****************  */

  var optionFullPageContact = {
      licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
      lockAnchors:false, // hum, on ne peut plus se servir de precedent / suivant en interne dans les pages...
      verticalCentered: false,
      css3: true,
      responsiveWidth: 769,
       afterResponsive: function(isResponsive){
       
      },
      afterLoad : function(index, newIndex, direction){
        $('body').removeClass('SlideTransition');
      }
    };


    /* *****************  */
      /* INIT FULL PAGE SI RECHARGEMENT PAGE  */
    /* *****************  */

   
    if($('body').hasClass('bodypage_about')){
      argsFullPage = optionFullPageAbout;
      Quel_page = 'about';
      CurrentPage = 'about';
       $('body').addClass('bg_bleu');
       //mouseOurFleet();
       EventMoveMouse();
    }else if($('body').hasClass('bodypage_team')){
      argsFullPage = optionFullPageTeam;
      Quel_page = 'team';
      CurrentPage = 'team';
    }
    else if($('body').hasClass('bodypage_contact')){
      argsFullPage = optionFullPageContact; // PODOM, on instancie pour page accueil (about) //
      Quel_page = 'contact';
      CurrentPage = 'contact';
      $('body').addClass('bg_bleu');
    }else{
       // $('body').addClass('bg_bleu');
       // argsFullPage = optionFullPageAbout; // PODOM, on instancie pour page accueil (about) //
       // Quel_page = 'about';
    }
    if (!$('body').hasClass('bodypage_investor') && !$('body').hasClass('bodypage_quarterly-report')){
      /* *****************  */
        /* SI PAS LA PAGE INVESTISOR OU UNE PAGE QUI RESSEMBLE (mentions légales etc.., alors creation full page)  */
      /* *****************  */
      createFullpage();
      active_menu(Quel_page);
    }

  
/* *****************  */
  /* INIT CLICK SUR UN LIEN AJAX */
/* *****************  */

  $("body").on("click",".js-ajax-link", function(evt){
      
       Quel_page = $(this).attr('data-page');
       if (CurrentPage != Quel_page){
       active_menu(Quel_page);
       NextHref = $(this).attr('href');
       
        // On enleve quelques class puisque on est sur la page /investisor/ est on est pas loggué. On a fait apparaitre par défaut le formulaire sur la droite.
        if($(this).hasClass('special_not_logged')){
          $('body').removeClass('SpecialNotLogged');
          $('.InvestorLogin').removeClass('Toappear');
        }
         if( !isAnimating ) GoToPage(Quel_page, true);
         firstLoad = true; 
        evt.preventDefault();
      }else{
        evt.preventDefault();
      }
  });

  
/* *****************  */
  /* FCT POUR ACTIVER LA TRANSITION Quel_page = page de destination */
  /* Apres transition, on lance l'ajax pour récupérer le contenu */
/* *****************  */
  function GoToPage(Quel_page, bool){

    //console.log('LOLOLO ' + Quel_page);
    if($sitenavigation.hasClass('toggled')) {
      $sitenavigation.removeClass('toggled');
    }
    
    //console.log("direction page PM  : " + Quel_page);
    if (Quel_page == 'about'){
         argsFullPage = optionFullPageAbout;
          $('body').addClass('bg_bleu');
          $('body').removeClass('LogotoPicto PictoBlanc');

      }else if(Quel_page == 'team'){
        argsFullPage = optionFullPageTeam;
         $('body').removeClass('bg_bleu PictoBlanc');
         $('body').addClass('LogotoPicto');
      }else if(Quel_page == 'investor' || Quel_page == 'quarterly-report'){
        argsFullPage = optionFullPageTeam;
         $('body').removeClass('bg_bleu PictoBlanc');
         $('body').addClass('LogotoPicto');
      }else if(Quel_page == 'contact'){
         argsFullPage = optionFullPageContact;
         $('body').addClass('PictoBlanc');
         $('body').removeClass('LogotoPicto'); // change addClass to RemoveClass to keep logo 
         $('body').addClass('bg_bleu');
      }



      OldPage = '';
      
      // On selectionne l'ancien contenu
      $ContainerFullPage = $(".js-mainwrapper");
     
    // TRANSITION AVEC LA CLASS : page-is-changing sur body //
    isAnimating = true;
    $('body').addClass('page-is-changing'); 

       // On attend la fin de la transition //
     $('.cd-loading-bar').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
        // Si un fullpage, on le détruit
        //console.log('AVANT LA');
        if ( $( 'html' ).hasClass( 'fp-enabled' ) ) {
            $.fn.fullpage.destroy('all');
        }
        //console.log('APRES LA');
        fullPageCreated = false; // il n'y a plus de fullpage
        $ContainerFullPage.remove(); // on supprime le contenu html // 
       // console.log('REMOVE FULL PAGE APRES TRANSITION / ON LANCE AJAX POUR RECUPERER NOUVEAU CONTENU');
        jQuery.post(
          ajaxurl,
          {
              'action': 'call_page',
              'param': Quel_page
          },
          function(response){ 
              NewHtml = response;
              appearNewPage(Quel_page,OldPage,bool);
          }
      );

        $('.cd-loading-bar').off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend'); //  ? Pour lancer transition sur loader
    });

    // Si le brower ne supporte pas les transitions (modernizr)
    if( !transitionsSupported() ) {
      
        // AJAX POUR LANCER LA NOUVELLE PAGE
        jQuery.post(
          ajaxurl,
          {
              'action': 'call_page',
              'param': Quel_page
          },
          function(response){ 
              NewHtml = response;
              appearNewPage(Quel_page,OldPage,bool);
          }
      );

    }
     
     
     
  }


/* *****************  */
  /*  FCT qui s'execute seulement une fois la transition fini + la récupération en ajax du contenu */
  /*  Quel_page = nouvelle page */
/* *****************  */
  function appearNewPage(Quel_page,OldPage, bool){

    if (Quel_page == 'team'){
      TitlePage = 'Team / Aeronautics fund';
    }else if (Quel_page == 'investor'){
       TitlePage = 'Investor / Aeronautics fund';
      // Remove block login
      $BlockLogin.removeClass(('Toappear'));
      $('body').removeClass(('BlockLoginToappear'));
    }else if (Quel_page == 'quarterly-report'){
      TitlePage = 'Quarterly Report / Aeronautics fund';
       // Remove block login
       $BlockLogin.removeClass(('Toappear'));
      $('body').removeClass(('BlockLoginToappear'));
    }else if (Quel_page == 'contact'){
       TitlePage = 'Contact / Aeronautics fund';
    }else{
       TitlePage = 'About / Aeronautics fund';
    }
    CurrentPage = Quel_page;

     $('#main').append(NewHtml); // On ajoute le nouveau contenu HTML

       var delay = ( transitionsSupported() ) ? DelayTransition : 0;

       // On attend le delay avant de faire les actions 
        setTimeout(function(){
            if (Quel_page != 'investor' && Quel_page != 'quarterly-report'){
                createFullpage();  // creation full page avec les bon paramètres passés précédement
                //console.log('CREATION FULL PAGE');
            }else{
                $('body').removeClass('SlideTransition'); // PODOM ? SLIDETRANSITION POUR LES AUTRES PAGES ?
                
            }
             $('body').removeClass(allClassPage); // On enleve toutes les class 
             $('body').addClass('bodypage_'+Quel_page); // ON ajoute la class de la futur page


            /* On initialise les différents modules si besoin*/
           initContactForm();
           initSlideClient();
           CloseBlocLogin();  
           initTeamMobile();
           OncliCkMessage();
          // mouseOurFleet();
           EventMoveMouse();
           toInitReadMore();
           toTranformIElogo();

            if (Quel_page == 'about'){
                  InitBtnHomeLightbox();
                  toInitSlideAbout();
            }

         

           if (Quel_page == 'investor'){
            var x = setTimeout(toTranformIElogo, 500); 
           }

           //ForIE11Trasnform();

        $('body').removeClass('page-is-changing'); // Fais apparaitre le contenu
        $('.cd-loading-bar').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
            isAnimating = false;
            // Variable a false, on peut de nouveau jouer l'animation
          $('.cd-loading-bar').off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend');
        });

        if( !transitionsSupported() ) isAnimating = false;
      }, delay);

      var BodyClass = $('body').attr('class');
      document.title = TitlePage;
       

       if(bool){
       //add the new page to the window.history //  //if the new page was triggered by a 'popstate' event, don't add it
        window.history.pushState({"html":NewHtml,"pageTitle":TitlePage,"Quel_page":Quel_page,"BodyClass":BodyClass},"", NextHref);
       }
      
  }


  /* *****************  */
  /* FCT POUR CREATION DU FULLPAGE AVEC LE BON ARGUMENT
  LE BON ARGUMENT EST PASSE A l'INIT OU EN FONCTION DE LA PAGE AU CHARGEMENT AJAX //
/* *****************  */
  function createFullpage(){
      if(fullPageCreated === false) {
         fullPageCreated = true;
        $('#fullpage').fullpage(argsFullPage);
        fullpage_api.setRecordHistory(false);
   }
  }


  window.onpopstate = function(e){
    if( firstLoad) {
      if(e.state && e.state.Quel_page){
          if( !isAnimating ) GoToPage(e.state.Quel_page, false);
          active_menu(e.state.Quel_page);
        }else{

          if(OldPage == 'about'){
            if( !isAnimating ) GoToPage("about", false);
             active_menu("about");
          }        

        }

     } // fin first load
     firstLoad = true; 
};


/* *****************  */
  /* FCT POUR ACTIVER CSS LE BON ITEM DE MENU
/* *****************  */
function active_menu(Quel_page){

  $('#menu_primary li').removeClass('current-menu-item');
  $('#menu_primary li a[data-page="'+Quel_page+'"]').parent().addClass('current-menu-item');

}


/* *****************  */
  /* FCT POUR ENLEVER BLOCK LOGIN
/* *****************  */

function CloseBlocLogin(){

  if($('body').hasClass('BlockLoginToappear')){
        $BlockLogin.removeClass(('Toappear'));
       $('body').removeClass(('BlockLoginToappear'));
  }

}

   
   

 /* *****************  */
  /* INITIALISATION DES FONCTIONNALITES PARTICULIERES 
/* *****************  */

/* *****************  */
  /* TAB POUR PAGE TEAM / MOBILE */

  function initTeamMobile() {
      // TAB MOBILE 
      /* if in drawer mode */
      //$(".tabmobile").hide();
      //$(".tabmobile:first").show();
      $(".js-tab-drawer").click(function() {
          if($(this).next().css('display') == 'none'){
              $(".js-tabmobile").hide();
              var d_activeTab = $(this).attr("rel"); 
              $("#"+d_activeTab).fadeIn();
            
            $(".js-tab-drawer").removeClass("d_active");
              $(this).addClass("d_active");
            
            // $("ul.tabs li").removeClass("active");
            // $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
        }else{
          $(this).next().slideUp(400);
          $(".js-tab-drawer").removeClass("d_active");
        }
        });
  }



  function initContactForm() {
       $( 'div.wpcf7 > form' ).each( function() {
        var $form = $( this );
        wpcf7.init($(this)[0]);       // >= 5.4
        //wpcf7.initForm( $form ); < 5/4
        if ( wpcf7.cached ) {
          $(this)[0].reset(); // > 5.4 ?
         // wpcf7.refill( $form ); // < 5.4
        }

        $(this).find('img.ajax-loader').last().remove();
       });
    }

  function initSlideClient() {
  
    $('.Client-Slider').slick({
      //setting-name: setting-value
          arrows:true,
          rows:2,
          slidesPerRow:3,
          activateRows:true,
          responsive: [
          {
            breakpoint: 1024,
            settings: {
             rows:2,
             slidesPerRow:2,
             dots: true,
             arrows:false
            }
          },
          {
            breakpoint: 600,
            settings: {
             slidesToShow: 2,
             rows:1,
             slidesPerRow:1,
             dots: true,
             arrows:false,
             slidesToScroll: 2,
            }
        }
      ]

      });

  }

  function toInitReadMore(){
    $('#toHide').hide();

    $('.js-ReadMore').click(function() {
        if($(this).attr('data-etat') == 'open'){
        $(this).attr('data-etat', 'close');
      }else{
        $(this).attr('data-etat', 'open');
      }
      $(this).parent().prev().slideToggle(300);
    });
  }

  function toTranformIElogo(){
    var g= document.querySelectorAll('.IeAnim');
    for (var i = 0; i < g.length; i++) {
       transform= getComputedStyle(g[i]).getPropertyValue('transform');
       g[i].setAttribute('transform', transform);
    }
  }

  toTranformIElogo();

  /////////
  //// ICI 
   

 //// PODOM  => DEMARER OU NE PAS DEMARER LE SLIDE ICI FIRST TIME ? AUTOLOAD ? 

  // POST commands to YouTube or Vimeo API
  function postMessageToPlayer(player, command){
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  }

  // When the slide is changing
  function playPauseVideo(slick, control){
    
    var currentSlide, slideType, startTime, player, video;

    currentSlide = slick.find(".slick-current");
    slideType = currentSlide.find('.item').attr("class").split(" ")[1];
    player = currentSlide.find("iframe").get(0);
    startTime = currentSlide.find('.item').data("video-start");
   
    if (slideType === "vimeo") {
      switch (control) {
        case "play":
          if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
            currentSlide.addClass('started');
            postMessageToPlayer(player, {
              "method": "setCurrentTime",
              "value" : startTime
            });
          }
          postMessageToPlayer(player, {
            "method": "play",
            "value" : 1
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "method": "pause",
            "value": 1
          });
          break;
      }
    } else if (slideType === "youtube") {
      switch (control) {
        case "play":
          // postMessageToPlayer(player, {
          //   "event": "command",
          //   "func": "mute"
          // });
          postMessageToPlayer(player, {
            "event": "command",
            "func": "playVideo"
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "event": "command",
            "func": "pauseVideo"
          });
          break;
      }
    } else if (slideType === "video") {
      video = currentSlide.children("video").get(0);
      if (video != null) {
        if (control === "play"){
          video.play();
        } else {
          video.pause();
        }
      }
    }
  }



function toInitSlideAbout(){
      var slideWrapper = $(".slider-media-js"),
      iframes = slideWrapper.find('.embed-player'),
      lazyImages = slideWrapper.find('.slide-image'),
      lazyCounter = 0;


    // Initialize
    slideWrapper.on("init", function(slick){
      slick = $(slick.currentTarget);
      // setTimeout(function(){
      //   playPauseVideo(slick,"play");
      // }, 1000);
    });
    // slideWrapper.on("beforeChange", function(event, slick) {
    //   slick = $(slick.$slider);
    //   playPauseVideo(slick,"pause");
    // });
    // slideWrapper.on("afterChange", function(event, slick) {
    //   slick = $(slick.$slider);
    //   playPauseVideo(slick,"play");
    // });
    // slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
    //   lazyCounter++;
    //   if (lazyCounter === lazyImages.length){
    //     lazyImages.addClass('show');
    //     // slideWrapper.slick("slickPlay");
    //   }
    // });

    //start the slider
    slideWrapper.slick({
      // fade:true,
      arrows:true,
      autoplaySpeed:4000,
      lazyLoad:"progressive",
      speed:600,
      dots:false,
      cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)",
      rows:1,
      slidesPerRow:1,
      activateRows:false,
      pauseOnHover:false,
      pauseOnFocus:false,
      draggable:false,
      responsive: [
          {
            breakpoint: 1024,
            settings: {
             dots: true,
             arrows:false
            }
          }
      ]
    });
}



  ///////
  ///// FIN ICI /////


  ///////
  ///// BTN LIGHTBOX HERE /////


var player;
function onYouTubeIframeAPIReady() {
  player = new YT.Player('player_youtube', {
    height: '360',
    width: '640',
    videoId: 'W8wVAL_3gV0',
 //   host: 'http ://www.youtube.com',
    playerVars : {
      'controls' : 1,
      'hl' : 'fr',
      'html5': 1,
      'iv_load_policy' : 3, // les annotations vidéo ne s'affichent pas par défaut. 
      'modestbranding' : 1,
      'rel':0,
      'showinfo':0,
      'related': 0,
      'autoplay': 1, //REGLES LES PB :)

    //  origin:'http://localhost'
      //playlist : "ID,ID,ID" // videos suivantes
    },
    events: {
      'onReady': onPlayerReady,
      //'onStateChange': onPlayerStateChange
    }
  });
}

// 4. The API will call this function when the video player is ready.
function onPlayerReady(event) {
//  alert('A');
  event.target.playVideo();
}

// 5. The API calls this function when the player's state changes.
//    The function indicates that when playing a video (state=1),
//    the player should play for six seconds and then stop.
var done = false;
function onPlayerStateChange(event) {
  //if (event.data == YT.PlayerState.PLAYING && !done) {
    //setTimeout(stopVideo, 6000);
    //done = true;
  //}
}
function playVideo() {
  player.playVideo();
}

function stopVideo() {
  player.stopVideo();
}

function InitBtnHomeLightbox(){
  
    $('a.l_f__video_intro').featherlight(
    $("#video_full_screen"),
    {
    type : "html",

    
    beforeOpen:function(event){
        //console.log(player);
        //playVideo();

      // $('.ContainerVideoFs-js').width(l_window - 200);
      // $('.ContainerVideoFs-js').height(h_window - 200);
      $('.featherlight').addClass('featherlight--specialVideoBg');
    },
    afterContent : function(event){
        //console.log(player);
      //playVideo();

      onYouTubeIframeAPIReady();

        // 3. This function creates an <iframe> (and YouTube player)
        //    after the API code downloads.
        // https://developers.google.com/youtube/player_parameters?playerVersion=HTML5&hl=fr

    }
  });

}
  ///////
  ///// FIN BTN LIGHTBOX HERE /////

}); // fin ready menu